import template from './rw-timepicker.html';

// eslint-disable-next-line no-undef
@Inject('$locale')
class RwTimepickerController {
  constructor() {
    this.showMeridian = this.$locale.DATETIME_FORMATS.shortTime.endsWith(' a');
  }
}

export default class RwTimepickerComponent {
  constructor() {
    this.template = template;
    this.controller = RwTimepickerController;
    this.require = 'ngModel';
    this.bindings = {
      ngModel: '=',
      name: '@?',
      required: '<?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-timepicker/rw-timepicker-component.js